import React from 'react';
import { ThemeProvider as StyledProvider } from 'styled-components';
import { ThemeProvider as MuiProvider } from '@material-ui/core/styles';
import { MockedProvider } from '@apollo/client/testing';

import { getStyledTheme } from 'src/theme/builders/styled';
import { getMuiTheme } from 'src/theme/builders/mui';

import {
  getColors,
  fonts as defaultFonts,
  shadows,
  buildScale,
  SPACES_INTERVAL,
  SPACES_SCALE_DEGREES,
} from 'src/theme';
import { ColorsProvider } from 'src/contexts/colors';
import { StoresProvider } from 'src/contexts/stores';
import { ViewportProvider } from 'src/contexts/viewport';
import QueryParamProvider from 'src/utils/query-param-provider';
import useCreateStores from 'src/state';
import { CommerceComponentsContext, defaultCommerceComponents } from 'src/theme/provider/commerce-components/context';

import { TestRouterProvider } from './test-router-provider';

export function TestProvider(props) {
  const builtInStores = useCreateStores();

  const {
    cart,
    children,
    colors = getColors(),
    DutchiePayEnrollment,
    fonts = defaultFonts,
    InstoreCart,
    market,
    mocks = [],
    mockStores,
    Modals,
    pusher,
    router,
    searchPreferences,
    UI,
    user,
  } = {
    ...builtInStores,
    ...props,
  };

  const customizableTheme = {
    colors: {
      navBar: '#fff',
      buttonsLinks: '#0b99e6',
      discountTag: '#f3583a',
    },
    fonts: {
      primary: 'Primary Font',
      secondary: 'Secondary Font',
    },
    utils: {
      isNavBarDark: false,
    },
    textTransforms: {
      buttons: 'none',
      links: 'none',
      tags: 'none',
    },
    radius: {
      sm: '0',
      md: '0',
      lg: '0',
      xl: '0',
      buttons: '0',
      tags: '0',
      cards: '0',
    },
  };

  const muiTheme = getMuiTheme({ colors, fonts, customized: customizableTheme });
  const styledTheme = getStyledTheme({
    colors,
    fonts,
    breakpoints: muiTheme.breakpoints,
    shadows,
    spaces: buildScale(SPACES_INTERVAL, SPACES_SCALE_DEGREES),
    customized: customizableTheme,
  });

  return (
    <TestRouterProvider router={router}>
      <MockedProvider mocks={mocks} addTypename={false}>
        <StoresProvider
          value={{
            UI,
            user,
            searchPreferences,
            market,
            cart,
            pusher,
            Modals,
            DutchiePayEnrollment,
            InstoreCart,
            ...mockStores,
          }}
        >
          <ColorsProvider value={colors}>
            <StyledProvider theme={styledTheme}>
              <MuiProvider theme={muiTheme}>
                <CommerceComponentsContext.Provider value={defaultCommerceComponents}>
                  <ViewportProvider>
                    {/* Mirror pages/_app.jsx so components using use-query-params (v2 requires a
                        provider) get the query-param context in tests. */}
                    <QueryParamProvider>{children}</QueryParamProvider>
                  </ViewportProvider>
                </CommerceComponentsContext.Provider>
              </MuiProvider>
            </StyledProvider>
          </ColorsProvider>
        </StoresProvider>
      </MockedProvider>
    </TestRouterProvider>
  );
}
